export enum DnsAttemptOutcome {
  Started = "started",
  Succeeded = "succeeded",
  Failed = "failed",
  Abandoned = "abandoned",
}
